var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9950_3862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 7.95719V36C34.9998 38.2091 33.209 40 30.9998 40H9C6.79086 40 5 38.2091 5 36V4C5 1.79086 6.79086 0 9 0H26.3367L34.9998 7.95719Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9950_3862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 7.95719H27.3367C26.7844 7.95719 26.3367 7.50947 26.3367 6.95719V0L34.9998 7.95719Z",
    fill: "#F2F4F7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.8344 32.716C16.8344 33.082 16.7504 33.418 16.5824 33.724C16.4144 34.024 16.1564 34.267 15.8084 34.453C15.4604 34.639 15.0284 34.732 14.5124 34.732H13.5584V37H12.0194V30.682H14.5124C15.0164 30.682 15.4424 30.769 15.7904 30.943C16.1384 31.117 16.3994 31.357 16.5734 31.663C16.7474 31.969 16.8344 32.32 16.8344 32.716ZM14.3954 33.508C14.6894 33.508 14.9084 33.439 15.0524 33.301C15.1964 33.163 15.2684 32.968 15.2684 32.716C15.2684 32.464 15.1964 32.269 15.0524 32.131C14.9084 31.993 14.6894 31.924 14.3954 31.924H13.5584V33.508H14.3954ZM20.0026 30.682C20.6686 30.682 21.2506 30.814 21.7486 31.078C22.2466 31.342 22.6306 31.714 22.9006 32.194C23.1766 32.668 23.3146 33.217 23.3146 33.841C23.3146 34.459 23.1766 35.008 22.9006 35.488C22.6306 35.968 22.2436 36.34 21.7396 36.604C21.2416 36.868 20.6626 37 20.0026 37H17.6356V30.682H20.0026ZM19.9036 35.668C20.4856 35.668 20.9386 35.509 21.2626 35.191C21.5866 34.873 21.7486 34.423 21.7486 33.841C21.7486 33.259 21.5866 32.806 21.2626 32.482C20.9386 32.158 20.4856 31.996 19.9036 31.996H19.1746V35.668H19.9036ZM28.2877 30.682V31.915H25.7137V33.247H27.6397V34.444H25.7137V37H24.1747V30.682H28.2877Z",
    fill: "#171717",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 20.5V23.8333C27.5 24.2754 27.3244 24.6993 27.0118 25.0118C26.6993 25.3244 26.2754 25.5 25.8333 25.5H14.1667C13.7246 25.5 13.3007 25.3244 12.9882 25.0118C12.6756 24.6993 12.5 24.2754 12.5 23.8333V20.5M15.8333 16.3333L20 20.5M20 20.5L24.1667 16.3333M20 20.5V10.5",
    stroke: "#171717",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9950_3862",
    x: 23.3367,
    y: -1,
    width: 12.6631,
    height: 11.9572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9950_3862"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9950_3862",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9950_3862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownload);
export default __webpack_public_path__ + "static/media/pdf-download.166ff1c548e55783509652b80a45ffea.svg";
export { ForwardRef as ReactComponent };